import { connect } from 'react-redux';

import FlowEditor from '../components/FlowEditor';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';


export default connect(
  null,
  defaultMapDispatchToProps
)(FlowEditor);